import { getScaleSize } from '../../../../../utils/utils';
import { TypographyComponent } from '../../../../../base/typography/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';

interface OutOfStockProps {
  scale?: number;
  fontFamily?: string;
}

const OutOfStock = ({ scale = 1, fontFamily = 'sans-serif' }: OutOfStockProps) => {
  const isSmallScreen = useMediaQuery('(min-width:1920px)');
  const isLargeScreen = useMediaQuery('(min-width:3840px)');

  return (
    <TypographyComponent
      sx={{
        backgroundColor: '#D7AD78',
        color: '#3C3333',
        textAlign: 'center',
        borderRadius: '4px',
        fontFamily: fontFamily,
        fontWeight: '400',
        fontSize: '5px',
        padding: '1.5px',
        ...(isSmallScreen ? { fontSize: getScaleSize(10, scale), padding: getScaleSize(3, scale) } : {}),
        ...(isLargeScreen ? { fontSize: getScaleSize(20, scale), padding: getScaleSize(6, scale) } : {}),
      }}
    >
      Out of stock
    </TypographyComponent>
  );
};

export default OutOfStock;
